export default class SocialLinks {
    facebook : string = "";
    twitter : string = "";
    instagram : string = "";
    youtube : string = "";
    discord : string = "";
    twitch : string = "";
    telegram : string = "";
}